import { BatchModel } from './BatchModel';
import { KeywordBatchDto } from './KeywordBatchDto';

export interface KeywordBatchModel {
    categoriesId: number[],
    keywords: BatchModel[],
    keywordsDto: KeywordBatchDto[]
}

export const keywordBatchModelInitial: KeywordBatchModel = {
    categoriesId: [],
    keywords: [],
    keywordsDto: []
};